import DropdownSearch from '../dropdownSearch'
import Program from './program'
import { PropTypes } from 'prop-types'

const Programmes = ({ colleges }) => {
  const allProgrammes = colleges?.map(college => ({
    title: college?.content?.properties?.collegeName?.name,
    description: college?.content?.properties?.collegeDescription?.markup,
    programmes: college?.content?.properties?.courses?.map(course => ({
      name: course?.name,
      link:
        '/all-programmes/' +
        course?.route?.path.split('/')[2] +
        '/' +
        course?.route?.path.split('/')[3]
    }))
  }))

  return (
    <div className='p-4 lg:px-16 xl:px-24 pb-12'>
      <div className='py-24 mb-16 md:mb-0 relative'>
        <div className='absolute w-full z-30'>
          <DropdownSearch />
        </div>
      </div>
      <div className='flex flex-col gap-10'>
        {allProgrammes?.map((programme, index) => (
          <Program key={index} {...programme} />
        ))}
      </div>
    </div>
  )
}
Programmes.propTypes = {
  colleges: PropTypes.any
}
export default Programmes
